import { useEffect, useState } from "react";

import {
  ArrowButton,
  TableMetadata,
  useTable,
} from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { getRoleList } from "../../api/User/UserApi";
import {
  ContentArea,
  ListTable,
  SearchCard,
  ToolbarTop,
} from "../../components";
import { Role } from "../../models/User";
import { userListRoute, userListUrl } from "../../routes/routes";

export function RoleList() {
  const { t } = useTranslation();
  const history = useHistory();

  const [tableData, setTableData] = useState<Role[]>([]);
  const tableMetadata: TableMetadata<Role> = {
    rowKey: "id",
    columns: [
      {
        columnKey: "name",
        header: t("common.role"),
        accessor: (item: Role) => {
          return <div>{item.name}</div>;
        },
      },
      {
        columnKey: "details",
        header: "",
        accessor: (item: Role) => {
          return (
            <div className={"text-right"}>
              <ArrowButton
                ariaLabel={t("common.details")}
                onClick={() => handleDetailsClicked(item.id)}
              />
            </div>
          );
        },
      },
    ],
    rowToolTip: () => undefined,
  };

  const [tableProps] = useTable({
    metadata: tableMetadata,
    data: tableData,
    pagination: false,
    totalItems: tableData.length,
    defaultSort: {},
  });

  useEffect(() => {
    (async () => {
      var result = await getRoleList();
      if (result && result.length > 0) {
        setTableData(result);
      }
    })();
  }, []);

  const handleDetailsClicked = (id?: number) => {
    if (id) {
      // history.push({
      //     pathname: userListRoute,
      //     state: { roles: [id] }
      // });
      history.push(userListUrl(id));
    }
  };
  return (
    <ContentArea>
      <ToolbarTop pageTitle={t("navigation.roleList")}></ToolbarTop>
      <SearchCard hideSearchBox={true}></SearchCard>
      <ListTable tableProps={tableProps} />
    </ContentArea>
  );
}
